import { ArrowBack } from "@mui/icons-material";
import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";
import ReactMarkdown from "react-markdown";
import { Link as RouterLink } from "react-router-dom";
import remarkGfm from "remark-gfm";
import dpaContent from "../../assets/content/data-processing-agreement.md?raw";
import { MARKDOWN_TABLE_SCROLLER } from "../common/markdown-table-scroller";

export const DataProcessingAgreement: React.FC = () => {
	return (
		<Box
			data-component="data-processing-agreement"
			sx={{
				minHeight: "100vh",
				bgcolor: "grey.50",
				py: { xs: 3, sm: 6 },
			}}
		>
			<Container component="main" maxWidth="md">
				{/* Header */}
				<Box sx={{ mb: 6 }}>
					<Link
						component={RouterLink}
						to="/login"
						sx={{
							display: "inline-flex",
							alignItems: "center",
							color: "primary.main",
							textDecoration: "none",
							fontSize: "0.875rem",
							fontWeight: 500,
							mb: 3,
							"&:hover": {
								textDecoration: "underline",
							},
						}}
					>
						<ArrowBack sx={{ fontSize: 16, mr: 1 }} />
						Back to Sign In
					</Link>

					<Typography
						variant="body1"
						sx={{
							color: "grey.600",
							fontSize: "1rem",
						}}
					>
						Last updated: {new Date().toLocaleDateString()}
					</Typography>
				</Box>

				{/* Markdown Content */}
				<Box
					data-component="dpa-content"
					sx={{
						bgcolor: "common.white",
						borderRadius: 2,
						p: { xs: 3, sm: 4, md: 6 },
						boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
						"& h1": {
							fontWeight: 600,
							color: "grey.900",
							fontSize: { xs: "2rem", sm: "2.5rem" },
							mb: 4,
							mt: 0,
						},
						"& h2": {
							fontWeight: 600,
							color: "grey.900",
							fontSize: "1.5rem",
							mt: 5,
							mb: 2,
							"&:first-of-type": {
								mt: 3,
							},
						},
						"& h3": {
							fontWeight: 600,
							color: "grey.900",
							fontSize: "1.15rem",
							mt: 3,
							mb: 1.5,
						},
						"& p": {
							fontSize: "1rem",
							lineHeight: 1.7,
							color: "grey.700",
							mb: 3,
						},
						"& ul": {
							pl: 3,
							color: "grey.700",
							mb: 3,
						},
						"& li": {
							mb: 1,
							fontSize: "1rem",
							lineHeight: 1.7,
						},
						"& hr": {
							border: "none",
							borderTop: "1px solid",
							borderColor: "divider",
							my: 4,
						},
						"& table": {
							width: "100%",
							borderCollapse: "collapse",
							mb: 3,
							fontSize: "0.9rem",
						},
						"& th, & td": {
							border: "1px solid",
							borderColor: "divider",
							px: 2,
							py: 1,
							textAlign: "left",
						},
						"& th": {
							bgcolor: "grey.100",
							fontWeight: 600,
						},
					}}
				>
					<ReactMarkdown
						remarkPlugins={[remarkGfm]}
						components={MARKDOWN_TABLE_SCROLLER}
					>
						{dpaContent}
					</ReactMarkdown>
				</Box>
			</Container>
		</Box>
	);
};
